import React, { useState, useEffect } from "react";
import { Row, Card, CardBody, Button, Label, Col } from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";
import Select from "react-select";
import { ToastContainer, toast, Bounce } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";

const EditCertificateRegistration = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  document.title = "Technical Hub | EditCertificateRegistration";
  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  const [courses, setCourses] = useState([]);
  const [selectedCourse, setSelectedCourse] = useState(null);
  const [addedby, setAddedBy] = useState("");
  const [seats, setSeats] = useState("");
  const [remarks, setRemarks] = useState("");
  const [eligibleRollNos, setEligibleRollNos] = useState("");
  const [eligibleColleges, setEligibleColleges] = useState("");
  const [eligibleBranches, setEligibleBranches] = useState("");
  const [eligibleYears, setEligibleYears] = useState("");
  const [registrationEndDate, setRegistrationEndDate] = useState("");
  const [slots, setSlots] = useState([{ slot: 1, capacity: "", time: "", day: "" }]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const curr_user = JSON.parse(localStorage.getItem('authUser'));
    if (curr_user) {
      setAddedBy(curr_user.first_name);
    }
    getCertificateOptions();
    getCertificateData();
  }, [id]);

  // Fetch certificate options for dropdown
  const getCertificateOptions = async () => {
    try {
      const response = await axios.get(`${backendUrl}get-certifications`);
      if (response.status === 200) {
        const certificationNames = response.data.map(item => ({
          label: item.certification_name,
          value: item.certification_name
        }));
        setCourses(certificationNames);
      }
    } catch (err) {
      console.log(err);
      toast.error("Failed to load certifications");
    }
  };

  // Fetch existing certificate data by ID
  const getCertificateData = async () => {
    try {
      setLoading(true);
      console.log("Fetching data for ID:", id);
      const response = await axios.get(
        `${backendUrl}get-certificate-registration-by-id/${id}`
      );
      console.log("Full API Response:", response);
      console.log("Response Data:", response.data);

      if (response.status === 200) {
        const data = response.data;
        // Pre-fill form with existing data
        if (data.data.certificate_name) {
          setSelectedCourse({
            label: data.data.certificate_name,
            value: data.data.certificate_name
          });
        }
console.log(data.data.certificate_name);

        if (data.data.seats) {
          setSeats(data.data.seats.toString());
        }

        // Handle arrays - convert to comma separated strings
        if (data.data.eligible_rollNos && Array.isArray(data.data.eligible_rollNos)) {
          setEligibleRollNos(data.data.eligible_rollNos.join(', '));
        } else if (data.data.eligible_rollNos) {
          setEligibleRollNos(data.data.eligible_rollNos);
        }

        if (data.data.eligible_college && Array.isArray(data.data.eligible_college)) {
          setEligibleColleges(data.data.eligible_college.join(', '));
        } else if (data.data.eligible_college) {
          setEligibleColleges(data.data.eligible_college);
        }

        if (data.data.eligible_branch && Array.isArray(data.data.eligible_branch)) {
          setEligibleBranches(data.data.eligible_branch.join(', '));
        } else if (data.data.eligible_branch) {
          setEligibleBranches(data.data.eligible_branch);
        }

        if (data.data.eligible_passoutyear && Array.isArray(data.data.eligible_passoutyear)) {
          setEligibleYears(data.data.eligible_passoutyear.join(', '));
        } else if (data.data.eligible_passoutyear) {
          setEligibleYears(data.data.eligible_passoutyear);
        }

        if (data.data.Remarks) {
          setRemarks(data.data.Remarks);
        }

        if (data.data.added_by) {
          setAddedBy(data.data.added_by);
        }

        // Format date for input field
        if (data.data.end_date) {
          const date = new Date(data.data.end_date);
          if (!isNaN(date.getTime())) {
            const formattedDate = date.toISOString().split('T')[0];
            setRegistrationEndDate(formattedDate);
          }
        }

        // Set slots data
        if (data.data.slots && Array.isArray(data.data.slots) && data.data.slots.length > 0) {
          setSlots(data.data.slots.map(slot => ({
            slot: slot.slot || 1,
            capacity: slot.capacity ? slot.capacity.toString() : "",
            time: slot.time || "",
            day: slot.day || ""
          })));
        }

        console.log("Form data set successfully");
      }
    } catch (err) {
      console.error("Error fetching certificate data:", err);
      if (err.response) {
        console.error("Server response:", err.response.data);
        console.error("Status:", err.response.status);
        toast.error(`Error: ${err.response.data.message || "Failed to load data"}`);
      } else if (err.request) {
        console.error("No response received:", err.request);
        toast.error("Network error: Unable to connect to server");
      } else {
        console.error("Error:", err.message);
        toast.error("Error loading certificate data");
      }
    } finally {
      setLoading(false);
    }
  };

  const handleSlotChange = (index, field, value) => {
    const newSlots = [...slots];
    newSlots[index][field] = value;
    setSlots(newSlots);
  };

  const addSlot = () => {
    const newSlotNumber = slots.length + 1;
    setSlots([...slots, { slot: newSlotNumber, capacity: "", time: "", day: "" }]);
  };

  const removeSlot = (index) => {
    if (slots.length <= 1) {
      toast.error("At least one slot is required");
      return;
    }

    const newSlots = [...slots];
    newSlots.splice(index, 1);

    // Renumber the slots
    const renumberedSlots = newSlots.map((slot, idx) => ({
      ...slot,
      slot: idx + 1
    }));

    setSlots(renumberedSlots);
  };

  const handleSelectedCourse = (selectedOption) => {
    setSelectedCourse(selectedOption);
  };

  const handleSubmit = async (event, values) => {
    event.preventDefault();

    // Prepare the data for submission
    const requestData = {
      certificate_name: selectedCourse ? selectedCourse.value : "",
      seats: seats ? parseInt(seats, 10) : 0,
      eligible_college: eligibleColleges ? eligibleColleges.split(',').map(item => item.trim()) : [],
      eligible_branch: eligibleBranches ? eligibleBranches.split(',').map(item => item.trim()) : [],
      eligible_passoutyear: eligibleYears ? eligibleYears.split(',').map(item => parseInt(item.trim(), 10)) : [],
      slots: slots.map(slot => ({
        slot: slot.slot,
        capacity: slot.capacity ? parseInt(slot.capacity, 10) : 0,
        time: slot.time || "",
        day: slot.day || ""
      })),
      eligible_rollNos: eligibleRollNos ? eligibleRollNos.split(',').map(item => item.trim()) : [],
      Remarks: remarks || "",
      added_by: addedby,
      end_date: registrationEndDate ? new Date(registrationEndDate).toISOString() : ""
    };

    console.log("Submitting data:", requestData);

    try {
      const response = await axios.put(
        `${backendUrl}update-certificate-registration/${id}`,
        requestData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200) {
        toast.success("Certification registration updated successfully!");
        navigate("/certifications-registration-list");
      }
    } catch (error) {
      console.error("Error updating certification registration:", error);
      if (error.response) {
        console.error("Server response:", error.response.data);
        toast.error(`Error: ${error.response.data.message || "Please try again."}`);
      } else {
        toast.error("Error updating certificate registration. Please try again.");
      }
    }
  };

  // Show loading state while data is being fetched
  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: "50vh" }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <span className="ms-2">Loading certificate data...</span>
      </div>
    );
  }

  return (
    <React.Fragment>
      <Row>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
          transition={Bounce}
        />
        <Col xl="12">
          <Card>
            <CardBody>
              <div className="d-flex justify-content-between align-items-center mb-4">
                <h4 className="card-title mb-0">Edit Certification Registration Data</h4>
                <Button color="secondary" size="sm" onClick={() => navigate("/certifications-registration-list")}>
                  Back to List
                </Button>
              </div>
              <AvForm className="needs-validation" onValidSubmit={handleSubmit}>
                <Row>
                  <Col md="4">
                    <div className="mb-4">
                      <Label htmlFor="course">Select Certificate Name</Label>
                      <Select
                        value={selectedCourse}
                        onChange={handleSelectedCourse}
                        options={courses}
                        classNamePrefix="select2-selection"
                      />
                    </div>
                  </Col>
                  <Col md="4">
                    <div className="mb-4">
                      <Label htmlFor="seats">Seats</Label>
                      <AvField
                        name="seats"
                        placeholder="Enter Seats"
                        type="number"
                        className="form-control"
                        id="seats"
                        value={seats}
                        onChange={(e) => setSeats(e.target.value)}
                      />
                    </div>
                  </Col>
                  <Col md="4">
                    <div className="mb-4">
                      <Label htmlFor="registration-end-date">Registration End Date</Label>
                      <AvField
                        name="registration-end-date"
                        type="date"
                        className="form-control"
                        id="registration-end-date"
                        value={registrationEndDate}
                        onChange={(e) => setRegistrationEndDate(e.target.value)}
                      />
                    </div>
                  </Col>
                </Row>

                <Row>
                  <Col md="6">
                    <div className="mb-4">
                      <Label htmlFor="roll-nos">Eligible Roll Nos</Label>
                      <AvField
                        tag="textarea"
                        name="eligible_rollnos"
                        id="roll-nos"
                        rows="3"
                        placeholder="Enter roll numbers separated by commas (e.g. 101, 102)"
                        className="form-control"
                        value={eligibleRollNos}
                        onChange={(e) => setEligibleRollNos(e.target.value)}
                      />
                    </div>
                  </Col>
                  <Col md="6">
                    <div className="mb-4">
                      <Label htmlFor="colleges">Eligible Colleges</Label>
                      <AvField
                        tag="textarea"
                        id="colleges"
                        name="colleges"
                        className="form-control"
                        rows="3"
                        placeholder="Enter colleges separated by commas (e.g., AEC, ABC College)"
                        value={eligibleColleges}
                        onChange={(e) => setEligibleColleges(e.target.value)}
                      />
                    </div>
                  </Col>
                </Row>

                <Row>
                  <Col md="6">
                    <div className="mb-4">
                      <Label htmlFor="branches">Eligible Branches</Label>
                      <AvField
                        tag="textarea"
                        id="branches"
                        name="branches"
                        className="form-control"
                        rows="3"
                        placeholder="Enter branches separated by commas (e.g., CSE, ECE, EEE)"
                        value={eligibleBranches}
                        onChange={(e) => setEligibleBranches(e.target.value)}
                      />
                    </div>
                  </Col>
                  <Col md="6">
                    <div className="mb-4">
                      <Label htmlFor="years">Eligible Passout Years</Label>
                      <AvField
                        tag="textarea"
                        id="years"
                        name="years"
                        className="form-control"
                        rows="3"
                        placeholder="Enter years separated by commas (e.g., 2024, 2025)"
                        value={eligibleYears}
                        onChange={(e) => setEligibleYears(e.target.value)}
                      />
                    </div>
                  </Col>
                </Row>

                <Row>
                  <Col md="12">
                    <div className="mb-4">
                      <div className="d-flex justify-content-between align-items-center mb-3">
                        <Label className="mb-0">Slots</Label>
                        <Button color="primary" size="sm" onClick={addSlot}>
                          + Add Slot
                        </Button>
                      </div>
                      {slots.map((slot, index) => (
                        <div key={index} className="border rounded p-3 mb-3">
                          <h6>Slot #{slot.slot}</h6>
                          <Row>
                            <Col md="3">
                              <AvField
                                name={`slots[${index}].capacity`}
                                placeholder="Capacity"
                                type="number"
                                className="form-control mb-2"
                                value={slot.capacity}
                                onChange={(e) => handleSlotChange(index, "capacity", e.target.value)}
                              />
                            </Col>
                            <Col md="3">
                              <AvField
                                name={`slots[${index}].time`}
                                placeholder="Time (e.g., 9:00 AM - 11:00 AM)"
                                type="text"
                                className="form-control mb-2"
                                value={slot.time}
                                onChange={(e) => handleSlotChange(index, "time", e.target.value)}
                              />
                            </Col>
                            <Col md="3">
                              <AvField
                                name={`slots[${index}].day`}
                                placeholder="Day (e.g., Monday, Wednesday)"
                                type="text"
                                className="form-control mb-2"
                                value={slot.day}
                                onChange={(e) => handleSlotChange(index, "day", e.target.value)}
                              />
                            </Col>
                            <Col md="3" className="d-flex align-items-end">
                              {slots.length > 1 && (
                                <Button color="danger" size="sm" onClick={() => removeSlot(index)}>
                                  Remove Slot
                                </Button>
                              )}
                            </Col>
                          </Row>
                        </div>
                      ))}
                    </div>
                  </Col>
                </Row>

                <Row>
                  <Col md="12">
                    <div className="mb-4">
                      <Label htmlFor="remarks">Remarks</Label>
                      <AvField
                        tag="textarea"
                        name="remarks"
                        placeholder="Enter Remarks"
                        className="form-control"
                        id="remarks"
                        rows="3"
                        value={remarks}
                        onChange={(e) => setRemarks(e.target.value)}
                      />
                    </div>
                  </Col>
                </Row>

                <div className="d-flex gap-2">
                  <Button color="primary" type="submit">
                    Update
                  </Button>
                  <Button color="secondary" onClick={() => navigate("/certification-registrations-list")}>
                    Cancel
                  </Button>
                </div>
              </AvForm>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default EditCertificateRegistration;
